import CustomCard from '../../components/CustomCard.tsx'
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs'
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns'
import UploadComponent, { UploadComponentHandle } from '../../components/global/UploadComponent.tsx'
import { MenuHeaderBar } from '../../components/global/MenuHeaderBar.tsx'
import { FC, useRef } from 'react'
import { ButtonComponent } from '@syncfusion/ej2-react-buttons'
import { useForm } from 'react-hook-form'

import style from './uploadPage.module.scss'

interface UploadPageProps {
}

interface formData {

}

const UploadPage: FC<UploadPageProps> = () => {
  const emailAddresses = ['organistaion@kbw.de', 'inhouseteam@kbw.de', 'planung@kbw.de', 'peter.edel@kbw.de', 'tagung@kbw.de', 'edv@kbw.de']
  const uploadForm = useForm<formData>()
  const { handleSubmit } = uploadForm
  const uploadComponentRef = useRef<UploadComponentHandle>(null)

  const onSubmit = () => {

  }

  const onError = () => {
  }

  const handleStartUpload = () => {
    uploadComponentRef.current?.startUpload()
  }
  return (<>
    <MenuHeaderBar headerContent={'Upload'}></MenuHeaderBar>
    <div className={`nw-content`}>
      <form style={{ height: '100%' }} onSubmit={handleSubmit(onSubmit, onError)} id="uploadForm">
        <CustomCard style={{ height: '100%' }} contentStyle={{ flex: 1 }} header={'Datei Upload'}>
          <div>
            <TextBoxComponent placeholder={'Bitte geben Sie einen gültigen Seminarcode ein:'} floatLabelType={'Always'}></TextBoxComponent>
            <DropDownListComponent dataSource={emailAddresses} placeholder={'Empfänger :'} floatLabelType={'Always'}></DropDownListComponent>
            {/*<TextAreaComponent placeholder="Bemerkungen :" floatLabelType="Always" />*/}
          </div>
          <div className={style.eUploadedFiles} style={{ height: 'calc(100% - 170px)', overflow: 'auto' }}>
            <UploadComponent buttonList={{ browse: 'Datei auswählen', upload: '', clear: '' }} ref={uploadComponentRef} autoUpload={false} />
          </div>
          <div style={{ alignContent: 'space-between', marginTop: '20px', textAlign: 'end' }}>
            <ButtonComponent onClick={handleStartUpload} isPrimary content={'Speichern'} style={{ marginTop: 'auto' }} />
          </div>


        </CustomCard>
      </form>
    </div>

  </>)

}

export default UploadPage